import { FC } from 'react';

export const IconFloor: FC = () => (
  // eslint-disable-next-line react/forbid-elements
  <svg fill="none" height="40" width="40" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 40V16L8 23.158V40" stroke="#737A8E" strokeWidth="2" />
    <path d="M27.833 21L12 26v10.833M12 2h17v14.894L12 22V2z" stroke="#737A8E" strokeWidth="2" />
    <path
      d="M39 31c0-2.761-2.45-5-5.474-5-2.758 0-5.04 1.864-5.418 4.288a3.595 3.595 0 00-1.74-.442c-1.86 0-3.368 1.378-3.368 3.077 0 1.7 1.508 3.077 3.368 3.077H39v-5zM2.5 12c0 2.21 1.653 4 3.692 4h5.539c1.53 0 2.769-1.343 2.769-3s-1.24-3-2.77-3H9.39C8.753 8.804 7.56 8 6.193 8 4.153 8 2.5 9.79 2.5 12z"
      fill="#fff"
      stroke="#737A8E"
      strokeWidth="2"
    />
    <path d="M15 5h2v3h-2zM18 5h2v3h-2zM21 5h2v3h-2zM24 5h2v3h-2z" fill="#737A8E" />
  </svg>
);

IconFloor.displayName = 'IconFloor';
